import { styled } from '@mui/material';

export const Root = styled('div')(({ theme }) => ({
  width: 308,
  minHeight: 392,
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.spacing(4),
  padding: theme.spacing(1),
}));
